import { CardMedia, Skeleton } from "@mui/material";
import { useAtomValue } from "jotai";
import { loadableDiscoverTemplateImageFamily } from "../store";

import type { BrandInfoSelected } from "../../brand-kit/types";
import type { LibraryTemplate } from "../library/types";
import type { FC } from "react";

export const MomentImage: FC<{
  template: LibraryTemplate;
  brandKitSelections: BrandInfoSelected | undefined;
}> = ({ template, brandKitSelections }) => {
  const imageLoader = useAtomValue(
    loadableDiscoverTemplateImageFamily({
      slug: template.slug,
      img: template.img,
      style: brandKitSelections?.branding_type || { type: "standard", value: "bold" },
    }),
  );

  const url =
    imageLoader?.state === "hasData" && imageLoader.data ? imageLoader.data.url : undefined;

  return (
    <>
      {url?.state === "hasData" && url.data ? (
        <CardMedia
          component="img"
          image={url.data}
          sx={{ position: "absolute", width: "100%", height: "100%" }}
          draggable={false}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          sx={{ position: "absolute", width: "100%", height: "100%" }}
        />
      )}
    </>
  );
};
